import {Routes} from "@angular/router";
import {WorkflowPartnerOneDowngradeCuComponent} from "./workflow-partner-one-downgrade-cu.component";

export const workflowPartnerOneDowngradeCuRouting: Routes = [
    { path: 'partner/downgrade-cu/:aid', component: WorkflowPartnerOneDowngradeCuComponent, children: [
        { path: 'info', component: WorkflowPartnerOneDowngradeCuComponent },
        { path: 'contact', component: WorkflowPartnerOneDowngradeCuComponent },
        { path: 'address', component: WorkflowPartnerOneDowngradeCuComponent },
        { path: 'payment', component: WorkflowPartnerOneDowngradeCuComponent },
        { path: 'checkout', component: WorkflowPartnerOneDowngradeCuComponent },
        { path: 'complete', component: WorkflowPartnerOneDowngradeCuComponent },
        { path: '', redirectTo: 'info', pathMatch: 'full' },
    ]},
]
